module.exports = __webpack_public_path__ + "img/19.8b814b08.jpg";